import { DialogContext, DialogProvider } from './dialog-context';

export { DialogContext, DialogProvider };

export default DialogContext;
